import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { KineticLines } from "@/components/Motion";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="blueprint-dark bg-ink">
      <SEO title="Page Not Found" path="/404" />
      <div className="mx-auto flex min-h-[70vh] max-w-7xl flex-col justify-center px-4 py-24 sm:px-6 lg:px-8">
        <p className="eyebrow eyebrow-light">Error 404</p>
        <KineticLines lines={["This page is outside", "the controlled environment."]}
          className="mt-5 font-display text-4xl font-medium leading-[1.08] tracking-tight text-white sm:text-5xl" />
        <p className="mt-6 max-w-lg text-base text-slate-400">
          The page you are looking for does not exist or has moved. Head back to the catalogue or start an enquiry.
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link to="/products" data-testid="nf-products-button"
            className="group inline-flex items-center justify-center gap-2 bg-accent px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-accent-dark">
            Explore Products <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
          <Link to="/" data-testid="nf-home-button"
            className="inline-flex items-center justify-center border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:border-white/50">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
